export default {
      id: "mask_img-usage",
      viewBox: "0 0 75 390",
      url: "../dist/images/" + "sprite.svg#mask_img-usage",
      toString: function () {
        return this.url;
      }
    }